import { BaseClass } from './base-class';
import { RoleName } from '@enums/role-name.enum';

export class Role extends BaseClass {
    name: RoleName;
    description: string;

    constructor(name: RoleName, description?: string) {
        super();
        this.name = name;
        this.description = description || '';
    }
}
